module.exports = __webpack_public_path__ + "img/22.fb68f98b.jpg";